<template>
  <section v-if="this.isAuthenticated" >
    Logged in as <strong> {{this.getUsername}} </strong>
    <button class="button is-primary is-small" @click="logoutAndAlert">
      Logout
    </button>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { Snackbar } from 'buefy/dist/components/snackbar'
  import BTooltip from "buefy/src/components/tooltip/Tooltip";
  import Notifications from "../../../../utils/Notifications";
  import { actions } from "@/store/BlogsStore/store";

  export default {
    name: "Logout",
    data() {
      return {
      }
    },
    computed:{
      ...mapGetters(['isAuthenticated', 'getUsername', 'getToken']),
    },
    methods: {
      ...mapActions(['logout']),
      logoutAndAlert(){
        Snackbar.open({message:`Logged Out!`});
        this.logout()
        actions.setBlogs(this.getToken);
      }
    }
  }
</script>